import ErrorBoundary from 'shared/components/ErrorBoundary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion  from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { DEPTH, HEIGHT, WIDTH } from 'models/constants';

import styles from './styles.css';

const ProductDimensions = props => {
	const { depth, height, width } = props;

	return (
		<ErrorBoundary>
			{width > 0 || height > 0 || depth > 0 ? (
				<div className={styles['product-expandable-spacer']}>
					<Accordion>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography variant="subtitle2">Dimensions</Typography>
						</AccordionSummary>
						<AccordionDetails style={{ display: 'block' }}>
							{width > 0 ? (
								<div className={styles['product-description']}>{`${WIDTH}: ${width}`}</div>
							) : null}
							{height > 0 ? (
								<div className={styles['product-description']}>{`${HEIGHT}: ${height}`}</div>
							) : null}
							{depth > 0 ? (
								<div className={styles['product-description']}>{`${DEPTH}: ${depth}`}</div>
							) : null}
						</AccordionDetails>
					</Accordion>
				</div>
			) : null}
		</ErrorBoundary>
	);
};

ProductDimensions.propTypes = {
	depth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ProductDimensions;
